import axios from 'axios'

import { SLOW_REQUEST_CONFIG } from '../util/operationProgressUtil'
import {
  determinarCodigosUnidades,
  determinarResponsabilidadeUnidade
} from '../controllers/unidadesController'

export const axiosWrapper = axios

export const RECUPERADOR_OPCOES_AUDITOR = '@itensActions/RECUPERADOR_OPCOES_AUDITOR'

export const getOpcaoAuditorUrl = (unidadesAtuais, responsabilidadeUnidade, somenteAtivos) => {
  let url = `/bff/processos/visao-por-auditor/opcoes-auditor`
  url = determinarCodigosUnidades(unidadesAtuais, url)
  url = determinarResponsabilidadeUnidade(responsabilidadeUnidade, url)
  url = url.concat(`&somenteAtivos=${somenteAtivos}`)
  return url
}

export const recuperarOpcoesAuditor =
  (unidadesAtuais, responsabilidadeUnidade, somenteAtivos) => (dispatch) =>
    axios
      .get(
        getOpcaoAuditorUrl(unidadesAtuais, responsabilidadeUnidade, somenteAtivos),
        SLOW_REQUEST_CONFIG
      )
      .then((response) =>
        dispatch({
          type: RECUPERADOR_OPCOES_AUDITOR,
          payload: response.data
        })
      )
